import {
  IonHeader,
  IonTitle,
  IonToolbar,
  IonContent,
  IonPage,
  IonButtons,
  isPlatform,
  IonMenuButton,
  IonItem,
  IonList,
  IonLabel,
  IonIcon,
} from "@ionic/react";
import { calendarOutline } from "ionicons/icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import findNotifications from "../../store/notificationsList/actions/findNotifications";
import { selectNotifications } from "../../store/notificationsList/selector/selectNotifications";

export const NotificationList: React.FC = () => {
  const notifications = useSelector(selectNotifications);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(findNotifications());
  }, [dispatch]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light"></IonMenuButton>
          </IonButtons>
          <IonTitle>Notificaciones</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Notificaciones</IonTitle>
          </IonToolbar>
        </IonHeader>

        <section
          style={{
            maxWidth: "800px",
          }}
          className={isPlatform("desktop") ? "ion-padding" : ""}
        >
          <IonList>
            {notifications.length === 0 && <p>No tienes notificaciones</p>}
            {notifications.map((notification) => (
              <IonItem key={notification.id} routerLink={notification.urlRedirect}>
                <IonLabel class="ion-text-wrap">
                  <h2 style={{ fontWeight: 500 }}>{notification.text}</h2>
                  <p className="ion-text-end">
                    <IonIcon icon={calendarOutline} class="ion-margin-end"></IonIcon>
                    {notification.createdAt}
                  </p>
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        </section>
      </IonContent>
    </IonPage>
  );
};
